const MenusActions = {
    LOAD_MENUS: "LOAD_MENUS",
    UPLOAD_SALES: "UPLOAD_SALES",
    CHANGE_RESTAURANT: "CHANGE_RESTAURANT",
    OPEN_ADD_DIALOG: "OPEN_ADD_DIALOG",
    CLOSE_ADD_DIALOG: "CLOSE_ADD_DIALOG",
};

export default MenusActions;
